import { useAuthSession } from '@/lib/auth/auth-session-provider';

export const useCurrentUser = () => {
  const { data: session, error } = useAuthSession();

  if (error) {
    // In Next dev, console.error may trigger the full-screen overlay.
    if (process.env.NODE_ENV === 'development') {
      console.warn('useCurrentUser: failed to load session', error);
    }

    return null;
  }

  return session?.user ?? null;
};
